import { type FC } from 'react';

import { SortListingButtonContainer } from '@/microfrontends/listing/shared/containers/SortListingButtonContainer';
import { ToMapListingButtonContainer } from '@/microfrontends/listing/shared/containers/ToMapListingButton';
import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { TitleContainer } from '../TitleContainer';

import { HeaderSEOBlock } from './components/HeaderSEOBlock';

export const HeaderSEOBlockContainer: FC = () => {
  const {
    listingProperties: { totalOffers },
  } = useListingContext();
  const { config } = useListingAppContext();

  /**
   * @todo Удалить RSку
   * @description Данный функционал появился в задаче CD-179378, будет удалён в задаче CD-173955
   */
  const listingMapEnabled = config.getStrict<boolean>('search-frontend.NewListingMap.Enabled');

  return (
    <HeaderSEOBlock
      offersCount={totalOffers}
      sortButton={totalOffers > 1 ? <SortListingButtonContainer /> : null}
      title={<TitleContainer />}
      toMapButton={listingMapEnabled ? null : <ToMapListingButtonContainer />}
    />
  );
};
